import React from "react";
import { useNavigate } from 'react-router-dom';
import Procurement from '../images/decidd/Procurement.png';
import Icon from '../images/card/pending.png';
import { MasterContext } from "../services/MasterContext";

export default function CreateCard(props) {
    let {userRole} = React.useContext(MasterContext);
    React.useEffect(() => {
        localStorage.removeItem('filterValue');
      },[])

    function checkRoutesAuth(context) {
        // console.log(context);
        const permissions = userRole?.data?.filter(
            permission => permission.applicationcontext === context
        );
        // console.log(permissions);
        
        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                if (permission.accessPersmission === 1) {
                    return true;
                }
            }
        }
        
        return false;
    }

    return (
        <div className="main">
            <div className="flex">
                {props.cardJson.map((data, index) => (checkRoutesAuth(data.auth)&&<Card key={index} {...data}/>
                ))}
            </div>
        </div>
    );
}


export function Card(props){
    const navigate = useNavigate();
    function handleClick(link) {
        if (link && link !== '') {
            navigate(link);
        }
    }
    return (
        <>
        <div className="recipe-card" onClick={() => handleClick(props.path)}>
            <div className="active">
                <div className="active-icon"><span></span>active</div>
                <div className="button" style={{ display: props.newpolicydisplay }}>
                    <img src={Icon} alt="" />
                    {/* <div className={data.newpolicybton}>
                        <p>{data.newpolicynumber}</p>
                    </div> */}
                </div>
            </div>
            <aside>
                <img src={Procurement} alt={props.title} />
            </aside>
            <article>
                <h3>{props.title}</h3>
                <div></div>
                <p>{props.text}</p>
            </article>
        </div>
        </>
    );
}